import React from 'react';
import { PlaceholderLoader } from '@hotelplan/components.common.placeholder-loader';
import { useDeviceType } from '@hotelplan/libs.context.device-type';

const PdpResortSkeleton = () => {
  const { mobile } = useDeviceType();

  const { w: width, h: height } = mobile
    ? { w: 413, h: 613 }
    : { w: 930, h: 816 };

  return (
    <div>
      <PlaceholderLoader
        width={width}
        height={height}
        uid="cardSkeleton"
        style={{ height: '100%', width: '100%', display: 'block' }}
      >
        {mobile ? (
          <>
            <rect y="120" width="413" height="189" rx="5" />
            <rect y="44" width="397" height="14" rx="4" />
            <rect y="64" width="336" height="14" rx="4" />
            <rect y="86" width="300" height="14" rx="4" />
            <rect width="87" height="24" rx="5" />
            <rect x="1" y="342" width="276" height="24" rx="5" />
            <rect x="1" y="406" width="113" height="16" rx="5" />
            <rect x="299" y="404" width="20" height="20" rx="10" />
            <rect x="344" y="404" width="20" height="20" rx="10" />
            <rect x="388" y="404" width="20" height="20" rx="10" />
            <rect x="366" y="404" width="20" height="20" rx="10" />
            <rect x="322" y="404" width="20" height="20" rx="10" />
            <rect x="1" y="451" width="113" height="16" rx="5" />
            <rect x="299" y="449" width="20" height="20" rx="10" />
            <rect x="344" y="449" width="20" height="20" rx="10" />
            <rect x="388" y="449" width="20" height="20" rx="10" />
            <rect x="366" y="449" width="20" height="20" rx="10" />
            <rect x="322" y="449" width="20" height="20" rx="10" />
            <rect x="1" y="494" width="113" height="16" rx="5" />
            <rect x="299" y="492" width="20" height="20" rx="10" />
            <rect x="344" y="492" width="20" height="20" rx="10" />
            <rect x="388" y="492" width="20" height="20" rx="10" />
            <rect x="366" y="492" width="20" height="20" rx="10" />
            <rect x="322" y="492" width="20" height="20" rx="10" />
            <rect y="390" width="413" height="1" />
            <rect y="436" width="413" height="1" />
            <rect y="524" width="413" height="1" />
            <rect y="480" width="413" height="1" />
            <rect x="1" y="539" width="113" height="16" rx="5" />
            <rect x="299" y="537" width="20" height="20" rx="10" />
            <rect x="344" y="537" width="20" height="20" rx="10" />
            <rect x="388" y="537" width="20" height="20" rx="10" />
            <rect x="366" y="537" width="20" height="20" rx="10" />
            <rect x="322" y="537" width="20" height="20" rx="10" />
            <rect x="1" y="582" width="113" height="16" rx="5" />
            <rect x="299" y="580" width="20" height="20" rx="10" />
            <rect x="344" y="580" width="20" height="20" rx="10" />
            <rect x="388" y="580" width="20" height="20" rx="10" />
            <rect x="366" y="580" width="20" height="20" rx="10" />
            <rect x="322" y="580" width="20" height="20" rx="10" />
            <rect y="612" width="413" height="1" />
            <rect y="568" width="413" height="1" />
          </>
        ) : (
          <>
            <rect y="115" width="930" height="362" rx="5" />
            <rect y="48" width="895" height="19" rx="4" />
            <rect y="74" width="468" height="19" rx="4" />
            <rect width="114" height="31" rx="5" />
            <rect y="507" width="319" height="31" rx="5" />
            <rect x="57" y="562" width="113" height="16" rx="5" />
            <rect x="1" y="655" width="113" height="16" rx="5" />
            <rect y="562" width="40" height="40" rx="10" />
            <rect x="55" y="581" width="20" height="20" rx="10" />
            <rect x="100" y="581" width="20" height="20" rx="10" />
            <rect x="144" y="581" width="20" height="20" rx="10" />
            <rect x="122" y="581" width="20" height="20" rx="10" />
            <rect x="78" y="581" width="20" height="20" rx="10" />
            <rect x="163" y="653" width="20" height="20" rx="10" />
            <rect x="208" y="653" width="20" height="20" rx="10" />
            <rect x="252" y="653" width="20" height="20" rx="10" />
            <rect x="230" y="653" width="20" height="20" rx="10" />
            <rect x="186" y="653" width="20" height="20" rx="10" />
            <rect x="1" y="687" width="113" height="16" rx="5" />
            <rect x="163" y="685" width="20" height="20" rx="10" />
            <rect x="208" y="685" width="20" height="20" rx="10" />
            <rect x="252" y="685" width="20" height="20" rx="10" />
            <rect x="230" y="685" width="20" height="20" rx="10" />
            <rect x="186" y="685" width="20" height="20" rx="10" />
            <rect x="1" y="719" width="113" height="16" rx="5" />
            <rect x="163" y="717" width="20" height="20" rx="10" />
            <rect x="208" y="717" width="20" height="20" rx="10" />
            <rect x="252" y="717" width="20" height="20" rx="10" />
            <rect x="230" y="717" width="20" height="20" rx="10" />
            <rect x="186" y="717" width="20" height="20" rx="10" />
            <rect x="389" y="562" width="113" height="16" rx="5" />
            <rect x="332" y="562" width="40" height="40" rx="10" />
            <rect x="387" y="581" width="20" height="20" rx="10" />
            <rect x="432" y="581" width="20" height="20" rx="10" />
            <rect x="476" y="581" width="20" height="20" rx="10" />
            <rect x="454" y="581" width="20" height="20" rx="10" />
            <rect x="410" y="581" width="20" height="20" rx="10" />
            <rect x="713" y="562" width="113" height="16" rx="5" />
            <rect x="656" y="562" width="40" height="40" rx="10" />
            <rect x="711" y="581" width="20" height="20" rx="10" />
            <rect x="756" y="581" width="20" height="20" rx="10" />
            <rect x="800" y="581" width="20" height="20" rx="10" />
            <rect x="778" y="581" width="20" height="20" rx="10" />
            <rect x="734" y="581" width="20" height="20" rx="10" />
            <rect y="634" width="272" height="1" />
            <rect y="753" width="272" height="1" />
            <rect x="333" y="654" width="113" height="16" rx="5" />
            <rect x="495" y="652" width="20" height="20" rx="10" />
            <rect x="540" y="652" width="20" height="20" rx="10" />
            <rect x="584" y="652" width="20" height="20" rx="10" />
            <rect x="562" y="652" width="20" height="20" rx="10" />
            <rect x="518" y="652" width="20" height="20" rx="10" />
            <rect x="333" y="686" width="113" height="16" rx="5" />
            <rect x="495" y="684" width="20" height="20" rx="10" />
            <rect x="540" y="684" width="20" height="20" rx="10" />
            <rect x="584" y="684" width="20" height="20" rx="10" />
            <rect x="562" y="684" width="20" height="20" rx="10" />
            <rect x="518" y="684" width="20" height="20" rx="10" />
            <rect x="333" y="718" width="113" height="16" rx="5" />
            <rect x="495" y="716" width="20" height="20" rx="10" />
            <rect x="540" y="716" width="20" height="20" rx="10" />
            <rect x="584" y="716" width="20" height="20" rx="10" />
            <rect x="562" y="716" width="20" height="20" rx="10" />
            <rect x="518" y="716" width="20" height="20" rx="10" />
            <rect x="333" y="718" width="113" height="16" rx="5" />
            <rect x="495" y="716" width="20" height="20" rx="10" />
            <rect x="540" y="716" width="20" height="20" rx="10" />
            <rect x="584" y="716" width="20" height="20" rx="10" />
            <rect x="562" y="716" width="20" height="20" rx="10" />
            <rect x="518" y="716" width="20" height="20" rx="10" />
            <rect x="333" y="750" width="113" height="16" rx="5" />
            <rect x="495" y="748" width="20" height="20" rx="10" />
            <rect x="540" y="748" width="20" height="20" rx="10" />
            <rect x="584" y="748" width="20" height="20" rx="10" />
            <rect x="562" y="748" width="20" height="20" rx="10" />
            <rect x="518" y="748" width="20" height="20" rx="10" />
            <rect x="332" y="784" width="272" height="1" />
            <rect x="659" y="654" width="113" height="16" rx="5" />
            <rect x="821" y="652" width="20" height="20" rx="10" />
            <rect x="866" y="652" width="20" height="20" rx="10" />
            <rect x="910" y="652" width="20" height="20" rx="10" />
            <rect x="888" y="652" width="20" height="20" rx="10" />
            <rect x="844" y="652" width="20" height="20" rx="10" />
            <rect x="659" y="686" width="113" height="16" rx="5" />
            <rect x="821" y="684" width="20" height="20" rx="10" />
            <rect x="866" y="684" width="20" height="20" rx="10" />
            <rect x="910" y="684" width="20" height="20" rx="10" />
            <rect x="888" y="684" width="20" height="20" rx="10" />
            <rect x="844" y="684" width="20" height="20" rx="10" />
            <rect x="659" y="718" width="113" height="16" rx="5" />
            <rect x="821" y="716" width="20" height="20" rx="10" />
            <rect x="866" y="716" width="20" height="20" rx="10" />
            <rect x="910" y="716" width="20" height="20" rx="10" />
            <rect x="888" y="716" width="20" height="20" rx="10" />
            <rect x="844" y="716" width="20" height="20" rx="10" />
            <rect x="659" y="749" width="113" height="16" rx="5" />
            <rect x="821" y="747" width="20" height="20" rx="10" />
            <rect x="866" y="747" width="20" height="20" rx="10" />
            <rect x="910" y="747" width="20" height="20" rx="10" />
            <rect x="888" y="747" width="20" height="20" rx="10" />
            <rect x="844" y="747" width="20" height="20" rx="10" />
            <rect x="659" y="781" width="113" height="16" rx="5" />
            <rect x="821" y="779" width="20" height="20" rx="10" />
            <rect x="866" y="779" width="20" height="20" rx="10" />
            <rect x="910" y="779" width="20" height="20" rx="10" />
            <rect x="888" y="779" width="20" height="20" rx="10" />
            <rect x="844" y="779" width="20" height="20" rx="10" />
            <rect x="658" y="815" width="272" height="1" />
            <rect x="332" y="633" width="256" height="1" />
            <rect width="256" height="1" transform="matrix(1 0 0 -1 658 634)" />
          </>
        )}
      </PlaceholderLoader>
    </div>
  );
};

export default PdpResortSkeleton;
